import React from "react";
import { legendItems } from "../constants/legendItems";

interface LegendProps {
  selectedFilter: string | null;
  setSelectedFilter: (color: string | null) => void;
  setShowUrlaubModal: (show: boolean) => void;
  setShowFerienModal: (show: boolean) => void;
}

const Legend: React.FC<LegendProps> = ({
  selectedFilter,
  setSelectedFilter,
  setShowUrlaubModal,
  setShowFerienModal,
}) => (
  <div className="calendar-legend">
    <h3 className="event-list-title">
      Legende {selectedFilter && "(Filter aktiv)"}
    </h3>
    <div className="legend-container">
      {legendItems.map((item) => {
        if (item.label === "Urlaub") {
          return (
            <div
              key={item.id}
              className={`legend-item ${
                selectedFilter === item.color ? "legend-item-active" : ""
              }`}
              onClick={() => setShowUrlaubModal(true)}
              style={{ cursor: "pointer" }}
            >
              <span
                className="legend-color-box"
                style={{ backgroundColor: item.color }}
              />
              <span>{item.label}</span>
            </div>
          );
        }
        if (item.label === "Schulferien") {
          return (
            <div
              key={item.id}
              className={`legend-item ${
                selectedFilter === item.color ? "legend-item-active" : ""
              }`}
              onClick={() => setShowFerienModal(true)}
              style={{ cursor: "pointer" }}
            >
              <span
                className="legend-color-box"
                style={{ backgroundColor: item.color }}
              />
              <span>{item.label}</span>
            </div>
          );
        }
        return (
          <div
            key={item.id}
            className={`legend-item ${
              selectedFilter === item.color ? "legend-item-active" : ""
            }`}
            onClick={() =>
              setSelectedFilter(
                selectedFilter === item.color ? null : item.color
              )
            }
            style={{ cursor: "pointer" }}
          >
            <span
              className="legend-color-box"
              style={{ backgroundColor: item.color }}
            />
            <span>{item.label}</span>
          </div>
        );
      })}
    </div>
  </div>
);

export default Legend;
